import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GoogleGetDirectionsOptionsType } from '../types/google/google-get-directions-options.type';
import { GoogleDrawDirectionsOptionsType } from '../types/google/google-draw-directions-options.type';
import { CommonUtils } from '@infodata-group/inf-commons';

// Todo :: Make this service available only if Google Maps is loaded
// Todo :: Make this service available on @infodata-group/inf-commons
// Todo :: Geocode text address to LatLng
// Todo :: Enable errors with NotificationService

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {
  public getLatLngFromAddress$(
    address: string,
  ): Observable<google.maps.LatLng> {
    return new Observable<google.maps.LatLng>((observer) => {
      if (!address) {
        observer.error('Address is required');
        return;
      }
      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({ address }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
            const location = results[0].geometry.location;
            observer.next(location);
            observer.complete();
          } else {
            observer.error(
              `Geocode was not successful for the following reason: ${status}`,
            );
          }
        })
        .then();
    });
  }

  public getDirection$(
    options: GoogleGetDirectionsOptionsType,
  ): Observable<google.maps.DirectionsResult> {
    const request: google.maps.DirectionsRequest = {
      origin: options.origin,
      destination: options.destination,
      travelMode: options.travelMode || google.maps.TravelMode.DRIVING,
      ...options.directionsRequest, // Spread the additional options if provided
    };
    return new Observable<google.maps.DirectionsResult>((observer) => {
      const directionsService = new google.maps.DirectionsService();
      directionsService.route(request, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK && result) {
          observer.next(result);
          observer.complete();
        } else {
          observer.error(status);
        }
      });
    });
  }

  public drawDirectionsResult(
    options: GoogleDrawDirectionsOptionsType,
  ): google.maps.DirectionsRenderer {
    const polylineOptions: google.maps.PolylineOptions = {
      strokeColor: CommonUtils.color('link'),
      strokeWeight: 3,
      strokeOpacity: 1,
    };

    const directionRenderer = new google.maps.DirectionsRenderer();
    directionRenderer.setMap(options.map);
    directionRenderer.setOptions({
      suppressMarkers: options.suppressMarkers || false,
      preserveViewport: options.preserveViewport || false,
      polylineOptions: polylineOptions,
      ...options.rendererOptions,
    });
    if (options.directionsResult) {
      directionRenderer.setDirections(options.directionsResult);
    }
    return directionRenderer;
  }
}
